import joi from "joi";
import { simplePath } from "../../utils.js";
import { baseSchema, emailValidation, nameValidation, socialAccountsFormValidation } from "./validation.js";
const POST_PROFILE_SETTINGS = 'v2/user-profile-settings';
function post_profile_settings_path() {
    return simplePath(POST_PROFILE_SETTINGS, {});
}
const schema = baseSchema.required();
const formSchema = baseSchema.append({
    email: emailValidation,
    avatarColor: joi.string().optional().allow(null, ''),
    userPortrait: joi.string().optional().allow(null, ''),
    socialAccounts: socialAccountsFormValidation
}).required();
const confirmModalForm = (tokenName)=>joi.object({
        name: joi.string().required().valid(tokenName).messages({
            'any.only': "You must input the required field correctly to finish this action."
        })
    });
const changeUserName = joi.object({
    name: nameValidation
});
const accountDeleteModalForm = (userName, userEmail)=>joi.object({
        name: joi.alternatives().try(joi.string().required().valid(userEmail).messages({
            'any.only': "You must input the correct email ".concat(userEmail, " to finish this action.")
        }), joi.string().required().valid(userName).messages({
            'any.only': "You must input the correct user name ".concat(userName, " to finish this action.")
        })),
        confirm: joi.string().valid('delete-account').messages({
            'any.only': 'You must type in "delete-account" to complete this action.'
        })
    });
export { POST_PROFILE_SETTINGS, accountDeleteModalForm, changeUserName, confirmModalForm, formSchema, post_profile_settings_path, schema };
